import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_COLOR_SUCCESS,
  GET_ALL_COLOR_REQUEST,
  GET_ALL_COLOR_FAILURE,
} from "./ActionType";

export const getAllColor = () => async (dispatch) => {
  dispatch({ type: GET_ALL_COLOR_REQUEST });
  try {
    const { data } = await publicAxios.get(`colors`);
    dispatch({ type: GET_ALL_COLOR_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_COLOR_FAILURE, payload: error.message });
  }
};
